module.exports = __webpack_public_path__ + "fonts/Roboto-400-vietnamese5.3230f9b.woff2";